import {
    ACTION_STATES,
    BasicAjaxAction,
    ComplexAction,
    createHandler,
    createReducer,
    DefaultAction,
} from "core/actions";
import { cloneDeep, isEqual } from "lodash";
import log from "loglevel";
import AdvertisingService from "services/advertisingService";
import envconfig from "../../../envconfig";

const today = null;

export const advFormDefaultValues = {
    name: "",

    advertisementType: null,
    filmRelease: null,

    advReported: false,

    advException: false,
    attributeTypes: [],
    contactID: null,
    codeValueList: null,
    contacts: [],
    quantity: 1,
    id: null,
    fromParentId: null,
};
export const initState = {
    form: {
        order: "DESC",
        orderBy: "ENTERED_DATE",
        page: 0,
        maxResults: 50,
        filmRelease: null,
        filmCategory: [],
        filmCompany: null,
        filmCode: "",
        filmCodeValue: "",
        ratingReason: "",
        filmRatingCode: "",
        filmDateCertifiedStart: today,
        filmDateCertifiedEnd: today,
        filmReleaseDateStart: today,
        filmReleaseDateEnd: today,
        filmEnteredDateStart: today,
        filmEnteredDateEnd: today,
        advType: [],
        advName: "",
        advStatus: null,
        advEnteredDateStart: today,
        advEnteredDateEnd: today,
        advReviewed: null,
        advReported: null,
        advFinal: null,
        advException: null,
        advInstructions: "",
        assocType: null,
        assocLocation: "",
        assocComments: "",
        assocPrivNotes: "",
        assocInciDateStart: today,
        assocInciDateEnd: today,
        assocInciTimeStart: "",
        assocInciTimeEnd: "",
        assocTitleCompany: null,
        tags: [],
    },
    advertisingForm: {
        open: false,
        editing: false,
        id: null,
        values: advFormDefaultValues,
    },
    defaultAdvTypes: [],
    loadingAdv: ACTION_STATES.NO_REQUEST,
    details: null,
    detailsReviewSelected: null,
    fromDetails: false,

    associationTypes: [],
    advertisementTypes: [],
    reviewStatusTypes: [],
    filmCodeTypes: [],
    filmRatingTypes: [],
    filmTitles: [],
    filmCompanies: [],
    expandAllRows: false,
    expandFromAllButton: true,
    loadFilmTitles: ACTION_STATES.NO_REQUEST,
    list: [],
    selectedAdv: [],
    globalSelectionMode: 0,
    totalCount: 0,
    addStatus: ACTION_STATES.NO_REQUEST,
    editStatus: ACTION_STATES.NO_REQUEST,
    loadStatus: ACTION_STATES.NO_REQUEST,
    loadFilmReleaseId: null,
    searchFormCleared: false,
    addingGlobalReportStatus: ACTION_STATES.NO_REQUEST,
    loadingStatus: ACTION_STATES.NO_REQUEST,
};

export class CHANGE_FORM extends ComplexAction {
    constructor() {
        const props = {
            error: false,
            loadingAtr: "loadStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("callRdx", state, payload);
        let form = {};
        if (Array.isArray(payload)) {
            form = { ...cloneDeep(state.form) };

            for (let change of payload) {
                log.debug(change);
                form[change.attribute] =
                    change.value !== "Invalid date"
                        ? change.attribute.match(/advType/) && !change.value
                            ? []
                            : change.value
                        : null;
            }
        }
        if (payload && payload.attribute) {
            form = {
                ...cloneDeep(state.form),
                [payload.attribute]:
                    payload.value !== "Invalid date"
                        ? payload.attribute.match(/advType/) && !payload.value
                            ? []
                            : payload.value
                        : null,
            };
        }
        if (Object.keys(form).length > 0) {
            let form_without_order = { ...form };
            delete form_without_order.order;
            delete form_without_order.orderBy;
            let initialForm = { ...initState.form };
            delete initialForm.order;
            delete initialForm.orderBy;

            const applyFilters = true;
            const loadFilmReleaseId =
                form.filmRelease && !isEqual(form.filmRelease, state.form.filmRelease) ? form.filmRelease.id : null;
            log.debug("apply filter", applyFilters);
            const selectedAdv = loadFilmReleaseId ? [] : state.selectedAdv;
            const globalSelectionMode = loadFilmReleaseId ? 0 : state.globalSelectionMode;
            if(payload.attribute !== "page") {
                form.page = 0;
            }
            return {
                ...state,
                form,
                loadStatus: ACTION_STATES.SEND,
                applyFilters,
                loadFilmReleaseId,
                selectedAdv,
                globalSelectionMode,
                searchFormCleared: false,
            };
        }
        return state;
    }
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            loadStatus: ACTION_STATES.SUCCESS,
            list: payload.data.results,
            totalCount: payload.data.totalCount,
            globalSelectionMode:
                payload.data.results.length > 0 && payload.data.results.length === state.selectedAdv.filter((adv) => adv.page === state.form.page).length
                    ? 1
                    : 0,
            form: {
                ...state.form,
                filmRelease: payload.filmRelease
                    ? {
                        ...payload.filmRelease,
                        value: payload.filmRelease.id,
                        label: payload.filmRelease.title,
                    }
                    : state.form.filmRelease
                        ? { ...state.form.filmRelease }
                        : null,
            },
            loadFilmReleaseId: null,
        });
    }
    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            loadStatus: ACTION_STATES.FAILED,
            loadError: payload.error,
        });
    }
}

export class CLEAR_FORM extends DefaultAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    callRdx(state) {
        return {
            ...state,
            form: {
                ...initState.form,
                advType: state.defaultAdvTypes,
            },
            applyFilters: true,
            list: [],
            searchFormCleared: true,
        };
    }
}

export class CHANGE_EXPANDED extends DefaultAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }

    callRdx(state, { payload }) {
        return {
            ...state,
            expandAllRows: payload[0],
            expandFromAllButton: payload[1],
        };
    }
}

export class TOGGLE_ADVERTISING_FORM extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }
    sendRdx(state, { payload }) {
        return {
            ...state,
            loadingStatus: ACTION_STATES.SEND,
            advertisingForm: {
                ...state.advertisingForm,
                open: !state.advertisingForm.open,
                editing: payload && payload.editing,
                id: payload && payload.id,
            },
            fromDetails: (!state.advertisingForm.open && payload && payload.fromDetails) || false,
        };
    }
    successRdx(state, { payload }) {
        return {
            ...state,
            loadingStatus: ACTION_STATES.SUCCESS,
            advertisingForm: {
                ...state.advertisingForm,
                values: payload ? payload.data : cloneDeep(initState.advertisingForm.values),
            },
        };
    }
}

export class TOGGLE_GLOBAL_SEARCH extends DefaultAction {}
export class REFRESH_TABLE extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            applyFilters: !isEqual(state.form, initState.form),
            loadStatus: ACTION_STATES.SEND,
        });
    }
}

export class ADD_ADV extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "addStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[ADD_ADV] sendRdx", state, payload);

        return {
            ...state,
            addStatus: ACTION_STATES.SEND,
            advertisingForm: {
                ...state.advertisingForm,
                values: payload.values,
                callback: payload.callback,
            },
        };
    }
    successRdx(state) {
        return Object.assign({}, state, {
            addStatus: ACTION_STATES.SUCCESS,
            advertisingForm: {
                open: false,
                editing: false,
                values: cloneDeep(initState.advertisingForm.values),
            },
        });
    }
}
export class EDIT_ADV extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "editStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[EDIT_ADV] sendRdx", state, payload);

        return {
            ...state,
            editStatus: ACTION_STATES.SEND,
            advertisingForm: {
                ...state.advertisingForm,
                values: payload.values,
                callback: payload.callback,
            },
        };
    }
    successRdx(state) {
        return Object.assign({}, state, {
            editStatus: ACTION_STATES.SUCCESS,
            advertisingForm: {
                open: false,
                editing: false,
                values: cloneDeep(initState.advertisingForm.values),
            },
            fromDetails: false,
        });
    }
}
export class VIEW_ADV extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "viewStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[VIEW_ADV] sendRdx", state, payload);

        return {
            ...state,
            viewStatus: ACTION_STATES.SEND,
            detailsId: payload,
            details: null,
            detailsReviewSelected: null,
        };
    }
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            viewStatus: ACTION_STATES.SUCCESS,
            detailsId: null,
            details: payload.data,
            detailsReviewSelected: payload.data.review,
        });
    }
}

export class TOGGLE_SELECTION extends DefaultAction {
    callRdx(state, { payload }) {
        const adv = payload;
        const index = state.selectedAdv.findIndex((a) => a.id === adv.id);
        let selectedAdv = cloneDeep(state.selectedAdv);

        if (index === -1) {
            selectedAdv.push({ ...adv, page: state.form.page });
        } else {
            selectedAdv = selectedAdv.filter((_, i) => i !== index);
        }

        let globalSelectionMode = -1;
        if (selectedAdv.filter((adv) => adv.page === state.form.page).length === state.list.length) {
            globalSelectionMode = 1;
        } else if (selectedAdv.length === 0) {
            globalSelectionMode = 0;
        }

        return Object.assign({}, state, {
            selectedAdv,
            globalSelectionMode: globalSelectionMode,
        });
    }
}

export class TOGGLE_GLOBAL_SELECTION extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            globalSelectionMode: state.globalSelectionMode === 1 || state.globalSelectionMode === -1 ? 0 : 1,
            selectedAdv:
                state.globalSelectionMode === 0
                    ? state.selectedAdv.slice().concat(state.list.map((adv) => ({ ...adv, page: state.form.page })))
                    : state.selectedAdv.filter((adv) => adv.page !== state.form.page),
        });
    }
}
export class CLOSE_SELECTION extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            globalSelectionMode: 0,
            selectedAdv: [],
        });
    }
}

export class SET_DEFAULT_ADV_TYPES extends DefaultAction {
    constructor() {
        super("defaultAdvTypes", null);
    }
}

export class CLEAR_ADV_FORM extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            advertisingForm: {
                open: false,
                editing: false,
                id: null,
                values: advFormDefaultValues,
            },
        });
    }
}

export class CREATE_ADV_FROM_EXISTING extends DefaultAction {
    callRdx(state, { payload }) {
        return {
            ...state,
            loadingStatus: ACTION_STATES.SEND,
            advertisingForm: {
                ...state.advertisingForm,
                open: true,
                editing: false,
                id: payload.id,
            },
            fromDetails: (!state.advertisingForm.open && payload && payload.fromDetails) || false,
        };
    }
}

export const actions = {
    ADD_ADV: new ADD_ADV(),
    EDIT_ADV: new EDIT_ADV(),
    VIEW_ADV: new VIEW_ADV(),
    CHANGE_FORM: new CHANGE_FORM("loadStatus"),
    REFRESH_TABLE: new REFRESH_TABLE("loadStatus"),
    CLEAR_FORM: new CLEAR_FORM(),
    CLEAR_ADV_FORM: new CLEAR_ADV_FORM(),
    GET_ASSOCIATION_TYPE: new BasicAjaxAction(
        "GET_ASSOCIATION_TYPE",
        "associationTypes",
        AdvertisingService.getNomenclator
    ),
    GET_ADVERTISEMENT_TYPE: new BasicAjaxAction(
        "GET_ADVERTISEMENT_TYPE",
        "advertisementTypes",
        AdvertisingService.getNomenclator
    ),
    GET_REVIEW_STATUS_TYPE: new BasicAjaxAction(
        "GET_REVIEW_STATUS_TYPE",
        "reviewStatusTypes",
        AdvertisingService.getNomenclator
    ),
    GET_FILM_CODE_TYPE: new BasicAjaxAction("GET_FILM_CODE_TYPE", "filmCodeTypes", AdvertisingService.getNomenclator),
    GET_FILM_RATING_TYPE: new BasicAjaxAction(
        "GET_FILM_RATING_TYPE",
        "filmRatingTypes",
        AdvertisingService.getNomenclator
    ),
    GET_FILM_TITLE: new BasicAjaxAction("GET_FILM_TITLE", "filmTitles", AdvertisingService.getFilmByTitle, {
        loadingAtr: "loadFilmTitles",
        debounce: envconfig.SEARCH_INPUT_DEBOUNCE_TIME
    }),
    TOGGLE_ADVERTISING_FORM: new TOGGLE_ADVERTISING_FORM(),
    CHANGE_EXPANDED: new CHANGE_EXPANDED("expandAllRows"),
    TOGGLE_SELECTION: new TOGGLE_SELECTION(),
    TOGGLE_GLOBAL_SELECTION: new TOGGLE_GLOBAL_SELECTION(),
    SET_DEFAULT_ADV_TYPES: new SET_DEFAULT_ADV_TYPES(),
    CREATE_ADV_FROM_EXISTING: new CREATE_ADV_FROM_EXISTING(),
    CLOSE_SELECTION: new CLOSE_SELECTION(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const SelectedAdvSelector = (state) => state.advertising.selectedAdv;
